import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'

import { Footer } from 'components/footer/Footer'
import { Questions } from 'components/questions/Questions'
import { AnalyticsActionType } from 'types/analytics.type'
import { trackAnalytics } from 'utils/analytics'

import AllWorkTools from '../components/allWorkTools/AllWorkTools'
import MainBanner from '../components/mainBanner/MainBanner'
import WorkToolsSubhead from '../components/workToolsSubhead/WorkToolsSubhead'

export function App() {
  useEffect(() => {
    trackAnalytics({
      type: AnalyticsActionType.page,
      payload: 'pg_pv_toolsandsupport',
    })
  }, [])

  return (
    <BrowserRouter basename="/tools-and-support">
      <div>
        <MainBanner />
        <WorkToolsSubhead />
        <AllWorkTools />
        <Questions title="Questions? Get started here." />
        <Footer />
      </div>
    </BrowserRouter>
  )
}
